import Vue from "vue";

export default {
  actions: {
    getYears({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/finance/years")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getOverview({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get(
            "/finance/overview?" +
              new URLSearchParams({
                period: data.period,
                year: data.year,
                month: data.month,
                startDate: data.startDate,
                endDate: data.endDate,
              }).toString()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getOverviewIncome({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get(
            "/finance/income/overview?" +
              new URLSearchParams({
                period: data.period,
                year: data.year,
                month: data.month,
                startDate: data.startDate,
                endDate: data.endDate,
              }).toString()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getOverviewExpenses({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get(
            "/finance/expenses/overview?" +
              new URLSearchParams({
                period: data.period,
                year: data.year,
                month: data.month,
                startDate: data.startDate,
                endDate: data.endDate,
              }).toString()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getFinanceOneTimeExpenses({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get(
            "/finance/expenses/one-time?" +
              new URLSearchParams({
                period: data.period,
                year: data.year,
                month: data.month,
                startDate: data.startDate,
                endDate: data.endDate,
              }).toString()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getFinanceRecurringExpenses({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get(
            "/finance/expenses/recurring?" +
              new URLSearchParams({
                period: data.period,
                year: data.year,
                month: data.month,
                startDate: data.startDate,
                endDate: data.endDate,
              }).toString()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getFinanceGearExpenses({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get(
            "/finance/expenses/gear?" +
              new URLSearchParams({
                period: data.period,
                year: data.year,
                month: data.month,
                startDate: data.startDate,
                endDate: data.endDate,
              }).toString()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getGearOverview({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/finance/gear/overview")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getIncomeProjects({ dispatch }, data) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get(
            "/finance/income/projects?" +
              new URLSearchParams({
                period: data.period,
                year: data.year,
                month: data.month,
                startDate: data.startDate,
                endDate: data.endDate,
              }).toString()
          )
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
    getCrewWithPay({ dispatch }) {
      return new Promise((resolve, reject) => {
        Vue.api
          .get("/finance/crew")
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            dispatch("handle_response_error", error);
            reject(error.response);
          });
      });
    },
  },
};
